// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__KfriY","info":"Note_info__3hDy0","note":"Note_note__1EyzW","actions":"Note_actions__Lr_2Z"};